<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormInLineQualityCheck
      :InLineQualityCheck="editInLineQualityCheck"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormInLineQualityCheck from '../components/FormInLineQualityCheck.vue';
import stockItem from './stockItem';

export default {
  components: {
    FormInLineQualityCheck,
  },
  name: 'EditInLineQualityCheck',
  module: 'InLineQualityCheck',
  mixins: [loading, stockItem],
  data() {
    return {
      /**
      * Get/Set editing InLineQualityCheck. Default to {}.
      */
      editInLineQualityCheck: {},
      /**
       * Query Id for InLineQualityCheck
       */
      inLineQualityCheckId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('inLineQualityChecks', ['inLineQualityChecks', 'inLineQualityCheck']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.inLineQualityCheckId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.$on('stockItem.loaded', (item) => {
      this.editInLineQualityCheck.stockItemId = item.id;
      this.editInLineQualityCheck.farm = item.deliveryNote.farm.name;
      this.editInLineQualityCheck.deliveryDate = this.formatDate(item.deliveryNote.receivingDate);
      this.editInLineQualityCheck.sizeRange = `${item.sizeMin} - ${item.sizeMax}`;
      this.$log.info('Prepopulation completed');
      this.$forceUpdate();
    });
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_inLineQualityCheck(this.inLineQualityCheckId);
      this.editInLineQualityCheck = this.inLineQualityCheck;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('inLineQualityChecks', ['LOAD_inLineQualityCheck', 'CREATE_inLineQualityCheck', 'UPDATE_inLineQualityCheck']),
    /** Method used to save the item
     */
    async save(inLineQualityCheck) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_inLineQualityCheck(inLineQualityCheck);
      } else {
        await this.UPDATE_inLineQualityCheck(inLineQualityCheck);
      }
      this.isSaving = false;
      this.$router.push({ name: 'in-line-quality-check-ListInLineQualityCheck' });
    },
  },
};
</script>

<docs>
# EditInLineQualityCheck example

'''js
<EditInLineQualityCheck :InLineQualityCheck="InLineQualityCheck" />
'''
</docs>
